import { render, staticRenderFns } from "./upcomming.vue?vue&type=template&id=94fa989e&"
import script from "./upcomming.vue?vue&type=script&lang=js&"
export * from "./upcomming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports